import { render } from "./AxialRotation.vue?vue&type=template&id=8fae300c&ts=true"
import script from "./AxialRotation.vue?vue&type=script&lang=ts"
export * from "./AxialRotation.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__